import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IActiveAddresses } from '../../api/interfaces'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

async function getActiveAddressesConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_active_adds', timeframe)) as IActiveAddresses[]
	const series1 = chartData.map((element: IActiveAddresses) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.SENDING_ADDRESSES }
	})
	const series2 = chartData.map((element: IActiveAddresses) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.RECEIVING_ADDRESSES }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'sending addresses',
			type: 'bars',
			seriesGroup: '[address #]',
			color: 'green'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'receiving addresses',
			type: 'bars',
			seriesGroup: '[address #]',
			color: 'orange'
		}
	]
	return { config: config, latestValue: series2[series2.length - 1].y, latestValueDate: series2[series2.length - 1].x }
}

const ActiveAddresses = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getActiveAddressesConfig)

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Active Addresses"
			chartDesc="The number of unique addresses that were active as a receiver or sender on THORChain. Helps measure ongoing network engagement and activity levels."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="55d6d2a0-ec2e-4fef-96ab-ca16c6c34053"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
		/>
	)
}

export default ActiveAddresses
